import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/shijisun/edu/projects/imui/node_modules/gatsby-theme-docz/src/base/Layout.js";
import Table from './lib/Table';
import CollapseTable from './lib/CollapseTable';
import TableSort from './lib/TableSort';
import DataTable from './lib/DataTable';
import AutoTable from './lib/AutoTable';
import AutoCollapseTable from './lib/AutoCollapseTable';
import './style/table.scss';
import './style/table_sort.scss';
import './style/data_table.scss';
import './style/common.scss';
import './style/collapse_table.scss';
import './style/auto_table.scss';
import { mockData, mockCGI } from './demo/util';
import Icon from '../icon/index';
import Button from '../button/index';
import { Playground, Props } from 'docz';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Example = makeShortcode("Example");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "table"
    }}>{`Table`}</h1>

    <h2 {...{
      "id": "props--methods"
    }}>{`Props & Methods`}</h2>
    <h3 {...{
      "id": "table-1"
    }}>{`Table`}</h3>
    <Props of={Table} mdxType="Props" />
    <h3 {...{
      "id": "collapsetable"
    }}>{`CollapseTable`}</h3>
    <pre><code parentName="pre" {...{}}>{`可折叠行表格,封装自Table，具有以下功能：
    - 可折叠部分行
`}</code></pre>
    <Props of={CollapseTable} mdxType="Props" />
    <h3 {...{
      "id": "data"
    }}>{`👆data`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`属性`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`说明`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`类型`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`默认值`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`row`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`一维数组，当前一行需要的数据。该行会一直显示，通过点击来控制是否显示对应被控制的折叠的行是否显示 如果数组元素是 React组件实例：展示元素本身 else：展示元素toString()  如果数组元素是空字符串或者==null会显示为'-'`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`array.isRequired`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`undefined`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`collapseRows`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`当前这行控制的可以被折叠的行,二维数组`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`arrayOf(PropTypes.array)`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`undefined`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`showCollapseRows`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`是否显示,当前这行控制的可以被折叠的行`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`arrayOf(PropTypes.array)`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "autotable"
    }}>{`AutoTable`}</h3>
    <pre><code parentName="pre" {...{}}>{`数据表格组件，封装自Table,具有以下功能：
    - 自动分页
    - 数据缓存
    - 选中
    - 排序
    - 筛选
`}</code></pre>
    <Props of={AutoTable} mdxType="Props" />
    <h3 {...{
      "id": "cols"
    }}>{`👆cols`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`属性`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`说明`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`类型`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`默认值`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`display`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`表格头部一列名称 如果数组元素是 React组件实例：展示元素本身 else：展示元素toString()`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`array.isRequired`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`undefined`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`width`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`表格一列所占宽度百分比`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`undefined`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`colspan`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`跨列,默认为1`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`1`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`sort`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`该表头是否需要排序，如果需要排序  1.该列只有一个排序选项：请传入一个只有一个元素的`}{`[SortType]`}{`类型的Arrays  2.该列有多个排序选项:请传入一个`}{`[SortType]`}{`类型的Arrays`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`arrayOf`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`undefined`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "sort"
    }}>{`👆sort`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`属性`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`说明`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`类型`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`默认值`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`display`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`表格头部一列名称 如果数组元素是 React组件实例：展示元素本身 else：展示元素toString()`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`array.isRequired`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`undefined`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`key`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`用于表示该排序方法的唯一key`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`string.isRequired`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`undefined`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`value`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`默认排序方法 1=顺序 -1=逆序 如果==null表示当前排序方法默认不启用`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`oneOf([-1, 1])`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`undefined`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "autocollapsetable"
    }}>{`AutoCollapseTable`}</h3>
    <pre><code parentName="pre" {...{}}>{`可折叠行表格数据表格组件，封装自CollapseTable,具有以下功能：
    - 可折叠部分行
    - 自动分页
    - 数据缓存
    - 选中
    - 排序
    - 筛选
`}</code></pre>
    <Props of={CollapseTable} mdxType="Props" />
    <h3 {...{
      "id": "tablesort"
    }}>{`TableSort`}</h3>
    <Props of={TableSort} mdxType="Props" />
    <h3 {...{
      "id": "options"
    }}>{`👆options`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`属性`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`说明`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`类型`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`默认值`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`display`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`用来展示`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`any.isRequired`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`undefined`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`value`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`用于回调`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`any.isRequired`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`undefined`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <h2 {...{
      "id": "basic-usage"
    }}>{`Basic Usage`}</h2>
    <Playground __position={5} __code={'<Table\n  cols={[\n    { display: \'角色\', width: 8 },\n    { display: \'描述\', width: 40 },\n    { display: \'成员数\', width: 5 },\n    {\n      display: (\n        <span>\n          操作\n          <Icon type=\"question\" />\n        </span>\n      ),\n      width: 20,\n    },\n  ]}\n  data={[\n    [\n      \'超级管理员\',\n      \'机构创始人，拥有所有功能的权限，且可以为其他角色自由配置功能。\',\n      1,\n      <a>管理成员</a>,\n    ],\n    [\n      \'教学管理员\',\n      \'机构创始人从所关联的成员中选取，协助管理机构，主要是教务教学相关工作的管理，默认拥有大部分权限。\',\n      62,\n      <a>管理成员</a>,\n    ],\n    [\n      \'老师\',\n      \'主要负责给学生上课，以及准备课程教案和教学资料。\',\n      230,\n      <a>管理成员</a>,\n    ],\n    [\n      \'助教\',\n      \'主要协助老师上课，工作内容包括在课堂上进行班级纪律管理，以及维护班级交流QQ群等。\',\n      232,\n      <a>管理成员</a>,\n    ],\n    [\n      \'销售管理员\',\n      \'销售模块的管理人员，默认拥有查询学员、分配销售人员并查看机构与销售人员的销售相关数据的权限。\',\n      3,\n      <a>管理成员</a>,\n    ],\n    [\n      \'教务\',\n      \'主要负责除了上课之外的大部分教务教学相关工作。\',\n      5,\n      <a>管理成员</a>,\n    ],\n    [\n      \'销售\',\n      \'销售人员，默认拥有查询被分配课程的学员、查看自己的销售数据并进行销售记录的相关权限。\',\n      12,\n      <a>管理成员</a>,\n    ],\n    [\'财务\', \'主要负责机构营收的查询和管理。\', 1, <a>管理成员</a>],\n    [\n      \'自定义1\',\n      \'自定义1\',\n      1,\n      <div>\n        <a>管理成员</a>\n        <br />\n        <a>编辑角色</a>\n        <br />\n        <a>删除</a>\n        <br />\n      </div>,\n    ],\n  ]}\n/>'} __scope={{
      props,
      DefaultLayout,
      Table,
      CollapseTable,
      TableSort,
      DataTable,
      AutoTable,
      AutoCollapseTable,
      mockData,
      mockCGI,
      Icon,
      Button,
      Playground,
      Props,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <Table cols={[{
        display: '角色',
        width: 8
      }, {
        display: '描述',
        width: 40
      }, {
        display: '成员数',
        width: 5
      }, {
        display: <span>操作
                  <Icon type="question" mdxType="Icon" />
                </span>,
        width: 20
      }]} data={[['超级管理员', '机构创始人，拥有所有功能的权限，且可以为其他角色自由配置功能。', 1, <a>管理成员</a>], ['教学管理员', '机构创始人从所关联的成员中选取，协助管理机构，主要是教务教学相关工作的管理，默认拥有大部分权限。', 62, <a>管理成员</a>], ['老师', '主要负责给学生上课，以及准备课程教案和教学资料。', 230, <a>管理成员</a>], ['助教', '主要协助老师上课，工作内容包括在课堂上进行班级纪律管理，以及维护班级交流QQ群等。', 232, <a>管理成员</a>], ['销售管理员', '销售模块的管理人员，默认拥有查询学员、分配销售人员并查看机构与销售人员的销售相关数据的权限。', 3, <a>管理成员</a>], ['教务', '主要负责除了上课之外的大部分教务教学相关工作。', 5, <a>管理成员</a>], ['销售', '销售人员，默认拥有查询被分配课程的学员、查看自己的销售数据并进行销售记录的相关权限。', 12, <a>管理成员</a>], ['财务', '主要负责机构营收的查询和管理。', 1, <a>管理成员</a>], ['自定义1', '自定义1', 1, <div>
                <a>管理成员</a>
                <br />
                <a>编辑角色</a>
                <br />
                <a>删除</a>
                <br />
              </div>]]} mdxType="Table" />
    </Playground>
    <h2 {...{
      "id": "complex-header"
    }}>{`Complex Header`}</h2>
    <Playground __position={6} __code={'<Table\n  cols={[\n    { display: \'角色\', width: 8 },\n    {\n      display: (\n        <table style={{ width: \'100%\' }}>\n          <tbody>\n            <tr>\n              <td>A</td>\n              <td>B</td>\n            </tr>\n            <tr>\n              <td colSpan=\"2\">C</td>\n            </tr>\n          </tbody>\n        </table>\n      ),\n      width: 40,\n    },\n    { display: \'成员数\', width: 5 },\n    { display: \'操作\', width: 20 },\n  ]}\n  data={[\n    [\n      \'超级管理员\',\n      \'机构创始人，拥有所有功能的权限，且可以为其他角色自由配置功能。\',\n      1,\n      <a>管理成员</a>,\n    ],\n    [\n      \'教学管理员\',\n      \'机构创始人从所关联的成员中选取，协助管理机构，主要是教务教学相关工作的管理，默认拥有大部分权限。\',\n      62,\n      <a>管理成员</a>,\n    ],\n    [\n      \'老师\',\n      \'主要负责给学生上课，以及准备课程教案和教学资料。\',\n      230,\n      <a>管理成员</a>,\n    ],\n    [\n      \'助教\',\n      \'主要协助老师上课，工作内容包括在课堂上进行班级纪律管理，以及维护班级交流QQ群等。\',\n      232,\n      <a>管理成员</a>,\n    ],\n  ]}\n/>'} __scope={{
      props,
      DefaultLayout,
      Table,
      CollapseTable,
      TableSort,
      DataTable,
      AutoTable,
      AutoCollapseTable,
      mockData,
      mockCGI,
      Icon,
      Button,
      Playground,
      Props,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <Table cols={[{
        display: '角色',
        width: 8
      }, {
        display: <table style={{
          width: '100%'
        }}>
                <tbody>
                <tr>
                    <td>A</td>
                    <td>B</td>
                </tr>
                <tr>
                    <td colSpan="2">C</td>
                </tr>
                </tbody>
            </table>,
        width: 40
      }, {
        display: '成员数',
        width: 5
      }, {
        display: '操作',
        width: 20
      }]} data={[['超级管理员', '机构创始人，拥有所有功能的权限，且可以为其他角色自由配置功能。', 1, <a>管理成员</a>], ['教学管理员', '机构创始人从所关联的成员中选取，协助管理机构，主要是教务教学相关工作的管理，默认拥有大部分权限。', 62, <a>管理成员</a>], ['老师', '主要负责给学生上课，以及准备课程教案和教学资料。', 230, <a>管理成员</a>], ['助教', '主要协助老师上课，工作内容包括在课堂上进行班级纪律管理，以及维护班级交流QQ群等。', 232, <a>管理成员</a>]]} mdxType="Table" />
    </Playground>
    <h2 {...{
      "id": "cross-column"
    }}>{`Cross Column`}</h2>
    <Playground __position={7} __code={'<Table\n  cols={[\n    { display: \'角色\', width: 8 },\n    { display: \'描述\', width: 80, colspan: 2 },\n    { display: \'操作\', width: 10 },\n  ]}\n  data={[\n    [\n      \'超级管理员\',\n      \'机构创始人，拥有所有功能的权限，且可以为其他角色自由配置功能。\',\n      1,\n      <a>管理成员</a>,\n    ],\n    [\n      \'教学管理员\',\n      \'机构创始人从所关联的成员中选取，协助管理机构，主要是教务教学相关工作的管理，默认拥有大部分权限。\',\n      62,\n      <a>管理成员</a>,\n    ],\n    [\n      \'老师\',\n      \'主要负责给学生上课，以及准备课程教案和教学资料。\',\n      230,\n      <a>管理成员</a>,\n    ],\n    [\n      \'助教\',\n      \'主要协助老师上课，工作内容包括在课堂上进行班级纪律管理，以及维护班级交流QQ群等。\',\n      232,\n      <a>管理成员</a>,\n    ],\n  ]}\n/>'} __scope={{
      props,
      DefaultLayout,
      Table,
      CollapseTable,
      TableSort,
      DataTable,
      AutoTable,
      AutoCollapseTable,
      mockData,
      mockCGI,
      Icon,
      Button,
      Playground,
      Props,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <Table cols={[{
        display: '角色',
        width: 8
      }, {
        display: '描述',
        width: 80,
        colspan: 2
      }, {
        display: '操作',
        width: 10
      }]} data={[['超级管理员', '机构创始人，拥有所有功能的权限，且可以为其他角色自由配置功能。', 1, <a>管理成员</a>], ['教学管理员', '机构创始人从所关联的成员中选取，协助管理机构，主要是教务教学相关工作的管理，默认拥有大部分权限。', 62, <a>管理成员</a>], ['老师', '主要负责给学生上课，以及准备课程教案和教学资料。', 230, <a>管理成员</a>], ['助教', '主要协助老师上课，工作内容包括在课堂上进行班级纪律管理，以及维护班级交流QQ群等。', 232, <a>管理成员</a>]]} mdxType="Table" />
    </Playground>
    <h2 {...{
      "id": "null-values"
    }}>{`Null Values`}</h2>
    <Playground __position={8} __code={'<Table\n  cols={[\n    { display: \'角色\', width: 8 },\n    { display: \'操作\', width: 10 },\n  ]}\n  data={[\n    [\'超级管理员\', null],\n    [\'教学管理员\', undefined],\n    [\'老师\', \'\'],\n    [\'助教\', 0],\n  ]}\n/>'} __scope={{
      props,
      DefaultLayout,
      Table,
      CollapseTable,
      TableSort,
      DataTable,
      AutoTable,
      AutoCollapseTable,
      mockData,
      mockCGI,
      Icon,
      Button,
      Playground,
      Props,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <Table cols={[{
        display: '角色',
        width: 8
      }, {
        display: '操作',
        width: 10
      }]} data={[['超级管理员', null], ['教学管理员', undefined], ['老师', ''], ['助教', 0]]} mdxType="Table" />
    </Playground>
    <h2 {...{
      "id": "select-rows"
    }}>{`Select Rows`}</h2>
    <Playground __position={9} __code={'<Table\n  cols={[\n    { display: \'A\', width: 45 },\n    { display: \'B\', width: 50 },\n  ]}\n  data={mockData(2, 4)}\n  canSelect\n  onSelectedChange={console.log}\n/>'} __scope={{
      props,
      DefaultLayout,
      Table,
      CollapseTable,
      TableSort,
      DataTable,
      AutoTable,
      AutoCollapseTable,
      mockData,
      mockCGI,
      Icon,
      Button,
      Playground,
      Props,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <Table cols={[{
        display: 'A',
        width: 45
      }, {
        display: 'B',
        width: 50
      }]} data={mockData(2, 4)} canSelect onSelectedChange={console.log} mdxType="Table" />
    </Playground>
    <h2 {...{
      "id": "no-data"
    }}>{`No Data`}</h2>
    <Playground __position={10} __code={'<Table\n  cols={[\n    { display: \'A\', width: 50 },\n    { display: \'B\', width: 50 },\n  ]}\n  data={[]}\n/>'} __scope={{
      props,
      DefaultLayout,
      Table,
      CollapseTable,
      TableSort,
      DataTable,
      AutoTable,
      AutoCollapseTable,
      mockData,
      mockCGI,
      Icon,
      Button,
      Playground,
      Props,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <Table cols={[{
        display: 'A',
        width: 50
      }, {
        display: 'B',
        width: 50
      }]} data={[]} mdxType="Table" />
    </Playground>
    <h2 {...{
      "id": "collapsetable-1"
    }}>{`CollapseTable`}</h2>
    <Playground __position={11} __code={'<CollapseTable\n  cols={[\n    { display: \'结算课程/服务\', width: 20 },\n    { display: \'结算订单数\', width: 10 },\n    { display: \'结算金额\', width: 10 },\n    { display: \'操作\', width: 10 },\n  ]}\n  data={[\n    {\n      row: [\'2016-06-29结算查看明细\', 2, \'0.04元\', <a>详情</a>],\n      collapseRows: [\n        [\'测试角标的课程\', 1, \'0.02元\', <a>查看明细</a>],\n        [\'雅思写作题\', 1, \'0.02元\', <a>查看明细</a>],\n      ],\n    },\n    {\n      row: [\'2016-05-29结算查看明细\', 2, \'3.09元\', <a>详情</a>],\n      collapseRows: [\n        [\'支付43王萌勿删\', 1, \'1.02元\', <a>查看明细</a>],\n        [\'支付优惠卷测试啊\', 1, \'0.02元\', <a>查看明细</a>],\n        [\'课中包退啊\', 1, \'2.07元\', <a>查看明细</a>],\n      ],\n    },\n  ]}\n/>'} __scope={{
      props,
      DefaultLayout,
      Table,
      CollapseTable,
      TableSort,
      DataTable,
      AutoTable,
      AutoCollapseTable,
      mockData,
      mockCGI,
      Icon,
      Button,
      Playground,
      Props,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <CollapseTable cols={[{
        display: '结算课程/服务',
        width: 20
      }, {
        display: '结算订单数',
        width: 10
      }, {
        display: '结算金额',
        width: 10
      }, {
        display: '操作',
        width: 10
      }]} data={[{
        row: ['2016-06-29结算查看明细', 2, '0.04元', <a>详情</a>],
        collapseRows: [['测试角标的课程', 1, '0.02元', <a>查看明细</a>], ['雅思写作题', 1, '0.02元', <a>查看明细</a>]]
      }, {
        row: ['2016-05-29结算查看明细', 2, '3.09元', <a>详情</a>],
        collapseRows: [['支付43王萌勿删', 1, '1.02元', <a>查看明细</a>], ['支付优惠卷测试啊', 1, '0.02元', <a>查看明细</a>], ['课中包退啊', 1, '2.07元', <a>查看明细</a>]]
      }]} mdxType="CollapseTable" />
    </Playground>
    <h2 {...{
      "id": "tablesort-1"
    }}>{`TableSort`}</h2>
    <Playground __position={12} __code={'() => {\n  class Example extends React.Component {\n    constructor(props) {\n      super(props)\n      this.sortData = this.sortData.bind(this)\n      this.state = {\n        sortTableData: [\n          [1, 9, 5],\n          [5, 1, 4],\n          [4, 4, 2],\n          [7, 8, 6],\n          [2, 7, 9],\n        ],\n      }\n      this.sortTableQuery = {\n        sort: \'\',\n        order: \'\',\n      }\n    }\n    render() {\n      return (\n        <>\n          <DataTable\n            cols={[\n              {\n                display: (\n                  <TableSort\n                    options={[\n                      { display: \'A\', key: \'a\' },\n                      { display: \'B\', key: \'b\' },\n                    ]}\n                    onChange={sort => {\n                      this.setState({\n                        sortTableData: this.sortData(sort),\n                      })\n                    }}\n                    active={\n                      this.sortTableQuery.sort === \'a\' ||\n                      this.sortTableQuery.sort === \'b\'\n                    }\n                    dropdownWidth={200}\n                  />\n                ),\n                width: 50,\n              },\n              {\n                display: (\n                  <TableSort\n                    options={[{ display: \'C\', key: \'c\' }]}\n                    onChange={sort => {\n                      this.setState({\n                        sortTableData: this.sortData(sort),\n                      })\n                    }}\n                    active={this.sortTableQuery.sort === \'c\'}\n                  />\n                ),\n                width: 50,\n              },\n            ]}\n            data={this.state.sortTableData.map(row => [\n              `A=${row[0]} B=${row[1]}`,\n              row[2],\n            ])}\n          />\n          <p>对字段进行排序使用TableSort组件传入cols属性</p>\n        </>\n      )\n    }\n    sortData(sort) {\n      this.sortTableQuery.sort = sort.sort\n      let sortTableData = [...this.state.sortTableData]\n      sortTableData.sort((x, y) => {\n        if (sort.sort === \'a\') {\n          return [x[0] - y[0]] * sort.order\n        } else if (sort.sort === \'b\') {\n          return [x[1] - y[1]] * sort.order\n        } else if (sort.sort === \'c\') {\n          return [x[2] - y[2]] * sort.order\n        }\n        return 0\n      })\n      return sortTableData\n    }\n  }\n  return <Example />\n}'} __scope={{
      props,
      DefaultLayout,
      Table,
      CollapseTable,
      TableSort,
      DataTable,
      AutoTable,
      AutoCollapseTable,
      mockData,
      mockCGI,
      Icon,
      Button,
      Playground,
      Props,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
      {() => {
        class Example extends React.Component {
          constructor(props) {
            super(props);
            this.sortData = this.sortData.bind(this);
            this.state = {
              sortTableData: [[1, 9, 5], [5, 1, 4], [4, 4, 2], [7, 8, 6], [2, 7, 9]]
            };
            this.sortTableQuery = {
              sort: '',
              order: ''
            };
          }

          render() {
            return <>
            <DataTable cols={[{
                display: <TableSort options={[{
                  display: 'A',
                  key: 'a'
                }, {
                  display: 'B',
                  key: 'b'
                }]} onChange={sort => {
                  this.setState({
                    sortTableData: this.sortData(sort)
                  });
                }} active={this.sortTableQuery.sort === 'a' || this.sortTableQuery.sort === 'b'} dropdownWidth={200} mdxType="TableSort" />,
                width: 50
              }, {
                display: <TableSort options={[{
                  display: 'C',
                  key: 'c'
                }]} onChange={sort => {
                  this.setState({
                    sortTableData: this.sortData(sort)
                  });
                }} active={this.sortTableQuery.sort === 'c'} mdxType="TableSort" />,
                width: 50
              }]} data={this.state.sortTableData.map(row => [`A=${row[0]} B=${row[1]}`, row[2]])} mdxType="DataTable" />
          <p>对字段进行排序使用TableSort组件传入cols属性</p>
            </>;
          }

          sortData(sort) {
            this.sortTableQuery.sort = sort.sort;
            let sortTableData = [...this.state.sortTableData];
            sortTableData.sort((x, y) => {
              if (sort.sort === 'a') {
                return [x[0] - y[0]] * sort.order;
              } else if (sort.sort === 'b') {
                return [x[1] - y[1]] * sort.order;
              } else if (sort.sort === 'c') {
                return [x[2] - y[2]] * sort.order;
              }

              return 0;
            });
            return sortTableData;
          }

        }

        return <Example mdxType="Example" />;
      }}
    </Playground>
    <h2 {...{
      "id": "autotable-basic-usage"
    }}>{`AutoTable Basic Usage`}</h2>
    <Playground __position={13} __code={'() => {\n  class Example extends React.Component {\n    constructor(props) {\n      super(props)\n      this.state = {\n        newPage: 0,\n        prevPage: 0,\n      }\n      this.translateRow = this.translateRow.bind(this)\n      this.fetch = this.fetch.bind(this)\n    }\n    fetch(query) {\n      return new Promise(resolve => {\n        mockCGI(query).then(json => {\n          let rows = json.data\n          let total = json.total\n          resolve({\n            rows,\n            total,\n          })\n        })\n      })\n    }\n    translateRow(rowData) {\n      return [\n        rowData.A,\n        rowData.B,\n        // owner\n        `${rowData.C}-${rowData.D}`,\n      ]\n    }\n    render() {\n      return (\n        <>\n          <AutoTable\n            maxRow={5}\n            cols={[\n              { display: \'A\', width: 10 },\n              { sort: [{ display: \'B\', key: \'B\', value: -1 }], width: 15 },\n              {\n                sort: [\n                  { display: \'C\', key: \'C\', value: 1 },\n                  { display: \'D\', key: \'D\' },\n                ],\n                width: 8,\n              },\n            ]}\n            fetch={this.fetch}\n            translateRow={this.translateRow}\n          />\n        </>\n      )\n    }\n  }\n  return <Example />\n}'} __scope={{
      props,
      DefaultLayout,
      Table,
      CollapseTable,
      TableSort,
      DataTable,
      AutoTable,
      AutoCollapseTable,
      mockData,
      mockCGI,
      Icon,
      Button,
      Playground,
      Props,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
      {() => {
        class Example extends React.Component {
          constructor(props) {
            super(props);
            this.state = {
              newPage: 0,
              prevPage: 0
            };
            this.translateRow = this.translateRow.bind(this);
            this.fetch = this.fetch.bind(this);
          }

          fetch(query) {
            return new Promise(resolve => {
              mockCGI(query).then(json => {
                let rows = json.data;
                let total = json.total;
                resolve({
                  rows,
                  total
                });
              });
            });
          }

          translateRow(rowData) {
            return [rowData.A, rowData.B, // owner
            `${rowData.C}-${rowData.D}`];
          }

          render() {
            return <>
            <AutoTable maxRow={5} cols={[{
                display: 'A',
                width: 10
              }, {
                sort: [{
                  display: 'B',
                  key: 'B',
                  value: -1
                }],
                width: 15
              }, {
                sort: [{
                  display: 'C',
                  key: 'C',
                  value: 1
                }, {
                  display: 'D',
                  key: 'D'
                }],
                width: 8
              }]} fetch={this.fetch} translateRow={this.translateRow} mdxType="AutoTable" />
            </>;
          }

        }

        return <Example mdxType="Example" />;
      }}
    </Playground>
    <h2 {...{
      "id": "autotable-persistence"
    }}>{`AutoTable Persistence`}</h2>
    <Playground __position={14} __code={'() => {\n  class Example extends React.Component {\n    constructor(props) {\n      super(props)\n      this.state = {\n        newPage: 0,\n        prevPage: 0,\n      }\n      this.translateRow = this.translateRow.bind(this)\n      this.fetch = this.fetch.bind(this)\n    }\n    fetch(query) {\n      return new Promise(resolve => {\n        mockCGI(query).then(json => {\n          let rows = json.data\n          let total = json.total\n          resolve({\n            rows,\n            total,\n          })\n        })\n      })\n    }\n    translateRow(rowData) {\n      return [\n        rowData.A,\n        rowData.B,\n        // owner\n        `${rowData.C}-${rowData.D}`,\n      ]\n    }\n    render() {\n      return (\n        <>\n          <AutoTable\n            maxRow={5}\n            cols={[\n              { display: \'A\', width: 10 },\n              { sort: [{ display: \'B\', key: \'B\', value: -1 }], width: 15 },\n              {\n                sort: [\n                  { display: \'C\', key: \'C\', value: 1 },\n                  { display: \'D\', key: \'D\' },\n                ],\n                width: 8,\n              },\n            ]}\n            fetch={this.fetch}\n            translateRow={this.translateRow}\n            persistence={{\n              get: () => {\n                if (typeof window !== \'undefined\' && window.localStorage) {\n                  return JSON.parse(\n                    window.localStorage.getItem(\'AutoTable-persistence\'),\n                  )\n                }\n              },\n              set: state => {\n                if (typeof window !== \'undefined\' && window.localStorage) {\n                  localStorage.setItem(\n                    \'AutoTable-persistence\',\n                    JSON.stringify(state),\n                  )\n                }\n              },\n            }}\n          />\n          <p>\n            AutoTable的state被持久化到了localStorage，先切换下页面，重新刷新页面可以看到这个AutoTable还是之前的样子\n          </p>\n        </>\n      )\n    }\n  }\n  return <Example />\n}'} __scope={{
      props,
      DefaultLayout,
      Table,
      CollapseTable,
      TableSort,
      DataTable,
      AutoTable,
      AutoCollapseTable,
      mockData,
      mockCGI,
      Icon,
      Button,
      Playground,
      Props,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
      {() => {
        class Example extends React.Component {
          constructor(props) {
            super(props);
            this.state = {
              newPage: 0,
              prevPage: 0
            };
            this.translateRow = this.translateRow.bind(this);
            this.fetch = this.fetch.bind(this);
          }

          fetch(query) {
            return new Promise(resolve => {
              mockCGI(query).then(json => {
                let rows = json.data;
                let total = json.total;
                resolve({
                  rows,
                  total
                });
              });
            });
          }

          translateRow(rowData) {
            return [rowData.A, rowData.B, // owner
            `${rowData.C}-${rowData.D}`];
          }

          render() {
            return <>
            <AutoTable maxRow={5} cols={[{
                display: 'A',
                width: 10
              }, {
                sort: [{
                  display: 'B',
                  key: 'B',
                  value: -1
                }],
                width: 15
              }, {
                sort: [{
                  display: 'C',
                  key: 'C',
                  value: 1
                }, {
                  display: 'D',
                  key: 'D'
                }],
                width: 8
              }]} fetch={this.fetch} translateRow={this.translateRow} persistence={{
                get: () => {
                  if (typeof window !== 'undefined' && window.localStorage) {
                    return JSON.parse(window.localStorage.getItem('AutoTable-persistence'));
                  }
                },
                set: state => {
                  if (typeof window !== 'undefined' && window.localStorage) {
                    localStorage.setItem('AutoTable-persistence', JSON.stringify(state));
                  }
                }
              }} mdxType="AutoTable" />
          <p>AutoTable的state被持久化到了localStorage，先切换下页面，重新刷新页面可以看到这个AutoTable还是之前的样子</p>
        </>;
          }

        }

        return <Example mdxType="Example" />;
      }}
    </Playground>
    <h2 {...{
      "id": "autotable-apis"
    }}>{`AutoTable APIs`}</h2>
    <Playground __position={15} __code={'() => {\n  class Example extends React.Component {\n    constructor(props) {\n      super(props)\n      this.state = {\n        newPage: 0,\n        prevPage: 0,\n      }\n      this.translateRow = this.translateRow.bind(this)\n      this.fetch = this.fetch.bind(this)\n    }\n    fetch(query) {\n      return new Promise(resolve => {\n        mockCGI(query).then(json => {\n          let rows = json.data\n          let total = json.total\n          resolve({\n            rows,\n            total,\n          })\n        })\n      })\n    }\n    translateRow(rowData) {\n      return [\n        rowData.A,\n        rowData.B,\n        // owner\n        `${rowData.C}-${rowData.D}`,\n      ]\n    }\n    render() {\n      return (\n        <>\n          <AutoTable\n            ref={t => (this.autoTable = t)}\n            maxRow={5}\n            cols={[\n              { display: \'A\', width: 10 },\n              { sort: [{ display: \'B\', key: \'B\', value: -1 }], width: 15 },\n              {\n                sort: [\n                  { display: \'C\', key: \'C\', value: 1 },\n                  { display: \'D\', key: \'D\' },\n                ],\n                width: 8,\n              },\n            ]}\n            fetch={this.fetch}\n            translateRow={this.translateRow}\n            onPageChange={this.onPageChange}\n          />\n          <br />\n          <Button\n            onClick={() => {\n              let page = Math.floor(Math.random() * 20)\n              this.autoTable.goPage(page, false)\n            }}\n          >\n            goPage\n          </Button>\n          <Button\n            onClick={() => {\n              let page = Math.floor(Math.random() * 20)\n              this.autoTable.showPage(page, false)\n            }}\n          >\n            showPage\n          </Button>\n          <Button\n            onClick={() => {\n              this.autoTable.reset([])\n            }}\n          >\n            reset\n          </Button>\n          <p>\n            跳转到第page页, 如果没有第page页的数据会回调fetch去加载更多的数据,\n            从0开始计数\n          </p>\n          <p>\n            跳转到第page页, 如果没有第page页的数据 不会\n            回调fetch去加载更多的数据, 业务侧自己保证第page页有数据\n          </p>\n          <p>每当表单的查询条件发生改变时请调reset方法重置AutoTable</p>\n        </>\n      )\n    }\n  }\n  return <Example />\n}'} __scope={{
      props,
      DefaultLayout,
      Table,
      CollapseTable,
      TableSort,
      DataTable,
      AutoTable,
      AutoCollapseTable,
      mockData,
      mockCGI,
      Icon,
      Button,
      Playground,
      Props,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
      {() => {
        class Example extends React.Component {
          constructor(props) {
            super(props);
            this.state = {
              newPage: 0,
              prevPage: 0
            };
            this.translateRow = this.translateRow.bind(this);
            this.fetch = this.fetch.bind(this);
          }

          fetch(query) {
            return new Promise(resolve => {
              mockCGI(query).then(json => {
                let rows = json.data;
                let total = json.total;
                resolve({
                  rows,
                  total
                });
              });
            });
          }

          translateRow(rowData) {
            return [rowData.A, rowData.B, // owner
            `${rowData.C}-${rowData.D}`];
          }

          render() {
            return <>
            <AutoTable ref={t => this.autoTable = t} maxRow={5} cols={[{
                display: 'A',
                width: 10
              }, {
                sort: [{
                  display: 'B',
                  key: 'B',
                  value: -1
                }],
                width: 15
              }, {
                sort: [{
                  display: 'C',
                  key: 'C',
                  value: 1
                }, {
                  display: 'D',
                  key: 'D'
                }],
                width: 8
              }]} fetch={this.fetch} translateRow={this.translateRow} onPageChange={this.onPageChange} mdxType="AutoTable" />
            <br />
            <Button onClick={() => {
                let page = Math.floor(Math.random() * 20);
                this.autoTable.goPage(page, false);
              }} mdxType="Button">goPage</Button>
            <Button onClick={() => {
                let page = Math.floor(Math.random() * 20);
                this.autoTable.showPage(page, false);
              }} mdxType="Button">showPage</Button>
            <Button onClick={() => {
                this.autoTable.reset([]);
              }} mdxType="Button">reset</Button>
            <p>跳转到第page页, 如果没有第page页的数据会回调fetch去加载更多的数据, 从0开始计数</p>
            <p>跳转到第page页, 如果没有第page页的数据 不会 回调fetch去加载更多的数据, 业务侧自己保证第page页有数据</p>
            <p>每当表单的查询条件发生改变时请调reset方法重置AutoTable</p>
            </>;
          }

        }

        return <Example mdxType="Example" />;
      }}
    </Playground>
    <h2 {...{
      "id": "autotable-error-retry"
    }}>{`AutoTable Error Retry`}</h2>
    <Playground __position={16} __code={'() => {\n  class Example extends React.Component {\n    constructor(props) {\n      super(props)\n      this.state = {\n        newPage: 0,\n        prevPage: 0,\n      }\n      this.translateRow = this.translateRow.bind(this)\n      this.fetch = this.fetch.bind(this)\n      this.errorFetch = this.errorFetch.bind(this)\n    }\n    fetch(query) {\n      return new Promise(resolve => {\n        mockCGI(query).then(json => {\n          let rows = json.data\n          let total = json.total\n          resolve({\n            rows,\n            total,\n          })\n        })\n      })\n    }\n    errorFetch() {\n      return new Promise((_, reject) => {\n        setTimeout(() => {\n          reject(\n            <div>\n              服务器发生错误\n              <Button\n                size=\"s\"\n                onClick={() => {\n                  this.autoErrorTable.reset()\n                }}\n              >\n                重试\n              </Button>\n            </div>,\n          )\n        }, 1000)\n      })\n    }\n    translateRow(rowData) {\n      return [\n        rowData.A,\n        rowData.B,\n        // owner\n        `${rowData.C}-${rowData.D}`,\n      ]\n    }\n    render() {\n      return (\n        <>\n          <AutoTable\n            ref={t => (this.autoErrorTable = t)}\n            maxRow={5}\n            cols={[\n              { display: \'A\', width: 10 },\n              { sort: [{ display: \'B\', key: \'B\', value: -1 }], width: 15 },\n              {\n                sort: [\n                  { display: \'C\', key: \'C\', value: 1 },\n                  { display: \'D\', key: \'D\' },\n                ],\n                width: 8,\n              },\n            ]}\n            fetch={this.errorFetch}\n            translateRow={this.translateRow}\n          />\n        </>\n      )\n    }\n  }\n  return <Example />\n}'} __scope={{
      props,
      DefaultLayout,
      Table,
      CollapseTable,
      TableSort,
      DataTable,
      AutoTable,
      AutoCollapseTable,
      mockData,
      mockCGI,
      Icon,
      Button,
      Playground,
      Props,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
      {() => {
        class Example extends React.Component {
          constructor(props) {
            super(props);
            this.state = {
              newPage: 0,
              prevPage: 0
            };
            this.translateRow = this.translateRow.bind(this);
            this.fetch = this.fetch.bind(this);
            this.errorFetch = this.errorFetch.bind(this);
          }

          fetch(query) {
            return new Promise(resolve => {
              mockCGI(query).then(json => {
                let rows = json.data;
                let total = json.total;
                resolve({
                  rows,
                  total
                });
              });
            });
          }

          errorFetch() {
            return new Promise((_, reject) => {
              setTimeout(() => {
                reject(<div>
                    服务器发生错误
                    <Button size="s" onClick={() => {
                    this.autoErrorTable.reset();
                  }} mdxType="Button">重试</Button>
                </div>);
              }, 1000);
            });
          }

          translateRow(rowData) {
            return [rowData.A, rowData.B, // owner
            `${rowData.C}-${rowData.D}`];
          }

          render() {
            return <>
            <AutoTable ref={t => this.autoErrorTable = t} maxRow={5} cols={[{
                display: 'A',
                width: 10
              }, {
                sort: [{
                  display: 'B',
                  key: 'B',
                  value: -1
                }],
                width: 15
              }, {
                sort: [{
                  display: 'C',
                  key: 'C',
                  value: 1
                }, {
                  display: 'D',
                  key: 'D'
                }],
                width: 8
              }]} fetch={this.errorFetch} translateRow={this.translateRow} mdxType="AutoTable" />
            </>;
          }

        }

        return <Example mdxType="Example" />;
      }}
    </Playground>
    <h2 {...{
      "id": "autocollapsetable-1"
    }}>{`AutoCollapseTable`}</h2>
    <Playground __position={17} __code={'() => {\n  class Example extends React.Component {\n    constructor(props) {\n      super(props)\n      this.fetch = this.fetch.bind(this)\n      this.translateRow = this.translateRow.bind(this)\n    }\n    fetch(query) {\n      return new Promise(resolve => {\n        mockCGI(query).then(json => {\n          let rows = json.data\n          let total = json.total\n          resolve({\n            rows,\n            total,\n          })\n        })\n      })\n    }\n    translateRow(rowData) {\n      return {\n        row: [\n          rowData.A,\n          rowData.B,\n          // owner\n          `${rowData.C}-${rowData.D}`,\n        ],\n        collapseRows: rowData.sub,\n      }\n    }\n    render() {\n      return (\n        <AutoCollapseTable\n          maxRow={3}\n          cols={[\n            { display: \'A\', width: 10 },\n            { sort: [{ display: \'B\', key: \'B\', value: -1 }], width: 15 },\n            {\n              sort: [\n                { display: \'C\', key: \'C\', value: 1 },\n                { display: \'D\', key: \'D\' },\n              ],\n              width: 8,\n            },\n          ]}\n          fetch={this.fetch}\n          translateRow={this.translateRow}\n        />\n      )\n    }\n  }\n  return <Example />\n}'} __scope={{
      props,
      DefaultLayout,
      Table,
      CollapseTable,
      TableSort,
      DataTable,
      AutoTable,
      AutoCollapseTable,
      mockData,
      mockCGI,
      Icon,
      Button,
      Playground,
      Props,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
      {() => {
        class Example extends React.Component {
          constructor(props) {
            super(props);
            this.fetch = this.fetch.bind(this);
            this.translateRow = this.translateRow.bind(this);
          }

          fetch(query) {
            return new Promise(resolve => {
              mockCGI(query).then(json => {
                let rows = json.data;
                let total = json.total;
                resolve({
                  rows,
                  total
                });
              });
            });
          }

          translateRow(rowData) {
            return {
              row: [rowData.A, rowData.B, // owner
              `${rowData.C}-${rowData.D}`],
              collapseRows: rowData.sub
            };
          }

          render() {
            return <AutoCollapseTable maxRow={3} cols={[{
              display: 'A',
              width: 10
            }, {
              sort: [{
                display: 'B',
                key: 'B',
                value: -1
              }],
              width: 15
            }, {
              sort: [{
                display: 'C',
                key: 'C',
                value: 1
              }, {
                display: 'D',
                key: 'D'
              }],
              width: 8
            }]} fetch={this.fetch} translateRow={this.translateRow} mdxType="AutoCollapseTable" />;
          }

        }

        return <Example mdxType="Example" />;
      }}
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      